<mat-dialog-content>
    <h3 style="color:#a20000;" translate>Login Exists</h3>
    <div style="padding-top:15px;" translate>Login information has already been provided for this email address.</div>
    <div style="padding-top:15px;" translate>Please use that information to access the site.</div>
    <div style="padding-top:15px;" translate *ngIf="loginSettings.ShowForgotPasswordLink">If you have forgotten your password, use the Forgot Password link on the login page.</div>
</mat-dialog-content>
<mat-dialog-actions style="position: sticky">
    <div class="footerRight">
        <tyl-button image="Cancel.png" label="Close" (clickEvent)="modalInstanceCloseClick()"></tyl-button>
    </div>
</mat-dialog-actions>